import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getCollectionList = createAsyncThunk(
  "get-collection",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("collection/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const createCollection = createAsyncThunk(
  "create-collection",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("collection", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const editCollection = createAsyncThunk(
  "edit-collection",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`collection/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const updateCollection = createAsyncThunk(
  "update-collection",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/collection/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const deleteCollection = createAsyncThunk(
  "delete-collection",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/collection/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const toggleCollectionStatus = createAsyncThunk(
  "toggle-collection-status",
  async ({ id, status }, { dispatch }) => {
    try {
      const response = await axios.patch(`/collection/${id}/status`, {
        status,
      });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

const collectionSlice = createSlice({
  name: "collection",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCollectionList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCollectionList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.collectionList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getCollectionList.rejected, (state) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default collectionSlice.reducer;
